import { EnumFormType } from './../enum/enum-form-type';
export class CabecalhoDTO {
    titleCard?: string;
    titleModule?: string;
    ScreenName?: string;
    ScreenType?: string;
}
